export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const CODE_DEF_LIST = 'CODE_DEF_LIST'
export const AUTH_TOKEN = 'AUTH_TOKEN'
export const IS_LOADING = 'IS_LOADING'
export const IS_LANG_JA = 'IS_LANG_JA'
export const FORM_ADMIN_ACCOUNT_ENTRY_LIST = 'FORM_ADMIN_ACCOUNT_ENTRY_LIST'
export const FORM_ADMIN_ACCOUNT_LIST = 'FORM_ADMIN_ACCOUNT_LIST'
export const FORM_ADMIN_MST_COMANY_LIST = 'FORM_ADMIN_MST_COMPANY_LIST'
export const FORM_ADMIN_ACCOUNT_SERVICE_APPLICATION_LIST = 'FORM_ADMIN_ACCOUNT_SERVICE_APPLICATION_LIST'
export const FROM_ADDRESS_LIST = 'FROM_ADDRESS_LIST'
